var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.21 48.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .pencil {\n        fill: currentColor;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "pencil",
    d: "M37.48,1.87,13,26.36A10.05,10.05,0,0,0,10,33.46v2.7a2,2,0,0,0,2,2h2.7a10,10,0,0,0,7.1-2.94l24.49-24.5a6.26,6.26,0,0,0,0-8.86A6.41,6.41,0,0,0,37.48,1.87Zm6,6L19,32.39a6.06,6.06,0,0,1-4.26,1.76h-.69v-.69a6.07,6.07,0,0,1,1.77-4.26L40.32,4.71a2.3,2.3,0,0,1,3.18,0A2.25,2.25,0,0,1,43.5,7.89Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "pencil",
    d: "M46.2,18a2,2,0,0,0-2,2V30.13h-8a6,6,0,0,0-6,6v8H10a6,6,0,0,1-6-6V10a6,6,0,0,1,6-6H28.21a2,2,0,0,0,0-4H10A10.06,10.06,0,0,0,0,10V38.17a10.06,10.06,0,0,0,10,10H32.83a10,10,0,0,0,7.1-2.94l5.34-5.34a10,10,0,0,0,2.94-7.1V20.05A2,2,0,0,0,46.2,18ZM37.09,42.43A6,6,0,0,1,34.15,44V36.16a2,2,0,0,1,2-2H44a6.08,6.08,0,0,1-1.6,2.94Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.e52c6c34.svg";
export { ForwardRef as ReactComponent };